module.exports = __webpack_public_path__ + "static/media/diskusi1.f96cd1a8.jpeg";